import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade, Grid } from 'swiper/modules';

// matchheight
import {matchHeight, matchHeightPerRow} from '../matchHeight';

function supporterSection() {
    var supporterSwiper = new Swiper(".supporter__swiper", {
        modules: [ Pagination, Navigation, Autoplay, Grid ],
        slidesPerView: 2,
        grid: {
            rows: 3,
            fill: "row"
        },
        spaceBetween: 0,
        navigation: {
            nextEl: ".supporter .stakeholder__next",
            prevEl: ".supporter .stakeholder__prev",
        },
        pagination: {
            el: ".supporter .stakeholder__pagination",
            clickable: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 5,
                grid: {
                    rows: 2,
                },
            },
        },
    });
}

function partnerSection() {
    var partnerSwiper = new Swiper(".partner__swiper", {
        modules: [ Pagination, Navigation, Autoplay, Grid ],
        slidesPerView: 2,
        grid: {
            rows: 3,
            fill: "row"
        },
        spaceBetween: 0,
        navigation: {
            nextEl: ".partner .stakeholder__next",
            prevEl: ".partner .stakeholder__prev",
        },
        pagination: {
            el: ".partner .stakeholder__pagination",
            clickable: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 5,
                grid: {
                    rows: 2,
                },
            },
        },
    });
}

function stakeholderCard() {
    const stakeholderItem = document.querySelectorAll('.stakeholder__item');
    matchHeightPerRow(stakeholderItem);
}

document.addEventListener('DOMContentLoaded', () => {
    supporterSection();
    partnerSection();
    stakeholderCard();
})

window.addEventListener('resize', () => {
    stakeholderCard();
})